import { r as Gt } from "./dom-qGGG2YCX.js";
import { i as a } from "./isUndefined-B5qXrATz.js";
import { g as lt, i as Ut } from "./getPageElevations-BuZyM94T.js";
const T = {
  h: {
    min: 0,
    max: 360
  },
  s: {
    min: 50,
    max: 75
  },
  l: {
    min: 60,
    max: 80
  }
}, h = 8, H = 19, $ = 46, y = 40, F = 35, B = 13, m = 27, x = 36, G = 37, b = 34, l = 33, U = 39, j = 32, V = 38, K = "top-start", W = "top-end", w = "bottom-start", z = "bottom-end", Y = "right-start", Z = "right-end", k = "left-start", q = "left-end", Q = /\[(\d+)]/g, J = /^(BV?)/, v = /^\d+$/, tt = /^\..+/, nt = /^#/, rt = /^#[A-Za-z]+[\w\-:.]*$/, ot = /(<([^>]+)>)/gi, st = /\B([A-Z])/g, et = /([a-z])([A-Z])/g, ct = /^[0-9]*\.?[0-9]+$/, Et = /\+/g, _t = /[-/\\^$*+?.()|[\]{}]/g, Rt = /[\s\uFEFF\xA0]+/g, Tt = /\s+/, ut = /\/\*$/, At = /(\s|^)(\w)/g, ft = /^\s+/, Ot = /\s+$/, at = /_/g, gt = /-(\w)/g, g = /[\p{Alpha}\p{Nd}]+/gu, Ct = /^\d+-\d\d?-\d\d?(?:\s|T|$)/, Nt = /-|\s|T/, St = /^([0-1]?[0-9]|2[0-3]):[0-5]?[0-9](:[0-5]?[0-9])?$/, it = /^.*(#[^#]+)$/, Dt = /%2C/g, Xt = /[!'()*]/g, pt = /^(\?|#|&)/, C = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, N = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, Pt = (t, n) => n.filter((r) => r !== t);
function S(t) {
  return Math.abs(
    t.split("").reduce((n, r) => r.charCodeAt(0) + ((n << 5) - n), 0)
  );
}
function E(t, n, r) {
  return Math.floor(t % (r - n) + n);
}
function dt(t) {
  t = t.replace(C, (r, o, s, e) => o + o + s + s + e + e);
  const n = N.exec(t);
  return n ? {
    r: parseInt(n[1], 16),
    g: parseInt(n[2], 16),
    b: parseInt(n[3], 16)
  } : null;
}
function _(t) {
  const n = t.toString(16);
  return n.length == 1 ? "0" + n : n;
}
function It(t, n, r) {
  return "#" + _(t) + _(n) + _(r);
}
function i(t, n = T) {
  const r = n != null && n.h ? [n.h.min, n.h.max] : [0, 360], o = n != null && n.s ? [n.s.min, n.s.max] : [0, 100], s = n != null && n.l ? [n.l.min, n.l.max] : [0, 100], e = S(t), A = E(e, ...r), f = E(e, ...o), O = E(e, ...s);
  return {
    h: A,
    s: f,
    l: O
  };
}
function D(t) {
  return `hsl(${t.h}, ${t.s}%, ${t.l}%)`;
}
function Lt(t, n = T) {
  return D(i(t, n));
}
function X(t = []) {
  return t.flatMap((n) => Array.isArray(n) ? X(n) : n);
}
const Mt = (t) => t === 0 ? "0" : `${t / 16}rem`;
function ht(t, n) {
  return typeof t != "string" || !t ? "" : (t.match(g) ?? []).reduce((r, o) => r + (+o == 0 || parseInt(o) ? parseInt(o) : o[0] || ""), "").toUpperCase().substring(0, n);
}
const Ht = (t, n) => n.concat(t), p = (t, n) => {
  const { parentElement: r } = n;
  return r ? t === r ? !0 : p(t, r) : !1;
}, c = (t) => Array.isArray(t), P = (t, n) => {
  const { parentElement: r } = t;
  return r ? n === r ? !0 : P(r, n) : !1;
}, $t = (t) => u(t) ? !0 : L(t) || c(t) ? t.length === 0 : R(t) ? Object.keys(t).length === 0 : !1, d = (t, n) => {
  if (Object.is(t, n))
    return !0;
  if (c(t) && c(n))
    return t.length === n.length && t.every((r, o) => r === n[o]);
  if (R(t) && R(n)) {
    const r = Object.keys(t), o = Object.keys(n);
    return d(r, o) && r.every((s) => t[s] === n[s]);
  }
  return !1;
}, u = (t) => I(t) || a(t), I = (t) => t === null, yt = (t) => typeof t == "number", R = (t) => typeof t == "object" && (t == null ? void 0 : t.constructor) === Object, L = (t) => typeof t == "string", Ft = (t) => u(t) ? [] : c(t) ? t : [t];
function Bt(t) {
  return t.replace(/var\((.*)\)/, (n, r) => r);
}
export {
  h as CODE_BACKSPACE,
  H as CODE_BREAK,
  $ as CODE_DELETE,
  y as CODE_DOWN,
  F as CODE_END,
  B as CODE_ENTER,
  m as CODE_ESC,
  x as CODE_HOME,
  G as CODE_LEFT,
  b as CODE_PAGEDOWN,
  l as CODE_PAGEUP,
  U as CODE_RIGHT,
  j as CODE_SPACE,
  V as CODE_UP,
  T as HSL_LIMITS,
  z as PLACEMENT_BOTTOM_END,
  w as PLACEMENT_BOTTOM_START,
  q as PLACEMENT_LEFT_END,
  k as PLACEMENT_LEFT_START,
  Z as PLACEMENT_RIGHT_END,
  Y as PLACEMENT_RIGHT_START,
  W as PLACEMENT_TOP_END,
  K as PLACEMENT_TOP_START,
  g as RX_ABBREVIATION_FROM_STRING,
  Q as RX_ARRAY_NOTATION,
  J as RX_BV_PREFIX,
  Ct as RX_DATE,
  Nt as RX_DATE_SPLIT,
  v as RX_DIGITS,
  Dt as RX_ENCODED_COMMA,
  Xt as RX_ENCODE_REVERSE,
  tt as RX_EXTENSION,
  nt as RX_HASH,
  rt as RX_HASH_ID,
  it as RX_HREF,
  ot as RX_HTML_TAGS,
  st as RX_HYPHENATE,
  N as RX_LONG_COLOR,
  et as RX_LOWER_UPPER,
  ct as RX_NUMBER,
  Et as RX_PLUS,
  pt as RX_QUERY_START,
  _t as RX_REGEXP_REPLACE,
  C as RX_SHORT_COLOR,
  Rt as RX_SPACES,
  Tt as RX_SPACE_SPLIT,
  ut as RX_STAR,
  At as RX_START_SPACE_WORD,
  St as RX_TIME,
  ft as RX_TRIM_LEFT,
  Ot as RX_TRIM_RIGHT,
  at as RX_UNDERSCORE,
  gt as RX_UN_KEBAB,
  Pt as exclude,
  Bt as extractCssVarName,
  X as flattenDeep,
  Lt as generateColorFromString,
  i as generateHslFromString,
  ht as getAbbreviation,
  S as getHashOfString,
  lt as getPageElevations,
  dt as hexToRgb,
  D as hslToColorString,
  Ht as include,
  p as isAncestor,
  c as isArray,
  P as isDescendant,
  $t as isEmpty,
  d as isEqual,
  u as isNil,
  I as isNull,
  yt as isNumber,
  R as isObject,
  L as isString,
  a as isUndefined,
  Ut as isVisible,
  E as normalize,
  Mt as pxToRem,
  Gt as requestAF,
  It as rgbToHex,
  Ft as toArray
};
